import { useSelector } from "react-redux";
import { closePhraseConfirmToggle } from "../../store/reducers/plantels/phrasesByPlantel.reducer";
import { togglePhraseActiveThunk } from "../../store/reducers/plantels/plantels.thunks";
import Modal from "../UI/Modal";
import { useDispatch } from "react-redux";

const ConfirmTogglePhraseModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, togglePhraseId, toggling, list } = useSelector(
    (state) => state.frasesByPlantel,
  );

  const phrase = list.find((p) => p.id === togglePhraseId);

  const handleClose = () => {
    if (!toggling) dispatch(closePhraseConfirmToggle());
  };

  const handleConfirm = async () => {
    await dispatch(togglePhraseActiveThunk(togglePhraseId));
    handleClose();
  };

  if (!phrase) return null;

  return (
    <Modal
      open={confirmModalOpen}
      title="Confirmar cambio de estado"
      size="md"
      onClose={handleClose}
    >
      <p>¿Seguro que deseas cambiar el estado de este talento?</p>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <button
          className="btn btn-secondary"
          onClick={handleClose}
          disabled={toggling}
        >
          Cancelar
        </button>

        <button
          className={`btn ${phrase.is_active ? "btn-danger" : "btn-success"}`}
          onClick={handleConfirm}
          disabled={toggling}
        >
          {toggling
            ? "Procesando..."
            : phrase.is_active
              ? "Desactivar"
              : "Activar"}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmTogglePhraseModal;
